'use strict';

jQuery(document).ready(function($) {

	$(window).on('load', function(event) {
		$('body').removeClass('state-loading')
	});

	$('.navigate').on('click', function(event) {
		event.preventDefault();

		var $target = $($(this).attr('href'));
		scrollTo($target);

		$('body').removeClass('state-menu-open');

	});

    $('.component-slideshow').slick({
        dots: true,
        arrows: false,
		autoplay: true,
		autoplaySpeed: 5000,
		fade: true
    })

	$('.action-fetch-news').on('click', function(event) {
		event.preventDefault();

		var $button = $(this);
		var max = $button.data('max')
		var paged = $button.data('paged')
		var data = {action: 'fetch:news', paged: paged}

		$.get(GRASS.ajax, data, function(html) {
			$('#news-excerpts').append(html)

			if (max === paged) {
				$button.remove()
			}else{
				$button.data('paged', paged + 1)
			}

		}, 'html')

	});

	$('.action-open-modal').on('click', function(event) {
		event.preventDefault();

		$('body').addClass('state-modal-open')

	});

	$('.action-close-modal').on('click', function(event) {
		event.preventDefault();

		$('body').removeClass('state-modal-open state-modal-newsletter-open')

	});

	$('.action-open-newsletter').on('click', function(event) {
		event.preventDefault();
		$('body').addClass('state-modal-newsletter-open')
	});

	$('.action-subscribe-newsletter').on('submit', function(event) {
		event.preventDefault();

		var data = $(this).serialize();
		var $rqrd = $('.rqrd',this);

		$rqrd.each(function(index, el) {

			var $t = $(this);

			if ($t.val() === '') {
				$t.addClass('error');
			}else{
				$t.removeClass('error');
			}

			if ($t.attr('type') === 'email') {
				if ( !validateEmail($t.val()) ) {
					$t.addClass('error');
				}else{
					$t.removeClass('error');
				}
			};

		});

		if ( $('.error.rqrd',this).length === 0 ) {

			$(this).addClass('state-success')

			$.post(GRASS.ajax, data, function(data) {
				console.log(data)
			},'json');
		};


	});

	$('.action-load-producer').on('click', function(event) {
		event.preventDefault();

		var info = $(this).data('info');

		var data = {
			action: 'fetch:producer',
			post_id: info.id
		}

		$.get(GRASS.ajax, data, function(html){
			$('#modal-content').html(html)
			$('body').addClass('state-modal-open')
		},'html')

	});

	$('.action-toggle-menu').on('click', function(event) {
		event.preventDefault();
		$('body').toggleClass('state-menu-open');
	});

	var height = $('.block-header').height();

	$(window).on('scroll', function(event) {

		if ($(this).scrollTop() > height) {
			$('body').addClass('state-snap-visible')
		}

		if ($(this).scrollTop() <= height) {
			$('body').removeClass('state-snap-visible')
		}

	});

	// forms

	$('.hnypt').remove();
	//
	// $('form').on('submit', function(event) {
	//
	// 	var data = $(this).serialize();
	// 	var $rqrd = $('.rqrd',this);
	// 	var $submit = $('.submit',this);
	//
	// 	$submit.attr('disabled','disabled');
	//
	// 	$rqrd.each(function(index, el) {
	//
	// 		var $t = $(this);
	//
	// 		if ($t.val() === '') {
	// 			$t.addClass('error');
	// 		}else{
	// 			$t.removeClass('error');
	// 		}
	//
	// 		if ($t.attr('type') === 'email') {
	// 			if ( !validateEmail($t.val()) ) {
	// 				$t.addClass('error');
	// 			}else{
	// 				$t.removeClass('error');
	// 			}
	// 		};
	//
	// 	});
	//
	// 	if ( $('.error.rqrd',this).length === 0 ) {
	// 		return true;
	// 	};
	//
	// 	$submit.removeAttr('disabled');
	//
	// 	return false;
	//
	// });


	// helpers

	function scrollTo($element){
		$('html, body').animate({scrollTop: $element.offset().top}, 500);
	}

	function validateEmail(email) {
	    var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
	    return re.test(email);
	}

});
